var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.6317H16",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63206 17.2633C8.43734 17.2633 8.17858 17.1455 8.05287 17.026L0.894606 10.2891C0.569472 9.97457 0.531877 9.46498 0.861711 9.09843C1.15689 8.77065 1.73225 8.76242 2.05271 9.06553L7.78974 14.4733L7.78974 0.842048C7.78974 0.376813 8.16686 4.70763e-07 8.63179 4.9981e-07C9.09703 5.28876e-07 9.47384 0.377122 9.47384 0.842048L9.47384 14.4733L15.2109 9.06553C15.5313 8.76243 16.0926 8.78387 16.4016 9.09843C16.7279 9.43032 16.6988 9.97958 16.3687 10.2891L9.21071 17.026C9.01657 17.2239 8.82973 17.26 8.63206 17.2633Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconWhite);
export default __webpack_public_path__ + "static/media/download-icon-white.1ca49a523ce9bd2a77c8cc798d8bbaad.svg";
export { ForwardRef as ReactComponent };